/**
 * @desc 初审驳回重新提交
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/wms/demandOrder/reject/firstTrial/resubmit`, {
      method: "POST",

      ...options,
    }),
  );
}
